// components/ScrollToTop.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
 const { pathname } = useLocation();

  useEffect(() => {
    // This is the magic — instant, no flicker, no jump
    window.scrollTo(0, 0);
    // OR even smoother (recommended):
    document.documentElement.scrollTo({
      top: 0,
      behavior: "instant"
    });
  }, [pathname]);

  return null;
}